import { Assessment } from "@appally/collections/Assessment";
import { AssessmentStatus } from "@appally/lib/redux/features/assessmentSlice";

export const checkStatus = (data?: Assessment): AssessmentStatus => {
  // Assume "not started" by default
  let status: AssessmentStatus = AssessmentStatus.NOT_STARTED;

  if (!!data?.progress?.assessment?.completed_at) {
    return AssessmentStatus.COMPLETED;
  }

  const started = [
    !!data?.progress?.about_you?.started_at,
    !!data?.progress?.about_your_job?.started_at,
    !!data?.progress?.workplace_challenges,
  ];

  if (started.length > 0) {
    status = AssessmentStatus.STARTED;
  }

  return status;
};
